import React from 'react';
const Error = () => (
    <>
        
    </>
);

export default Error;